define('pimSearchView',[
  'module',
  'marionette',
  'jquery',
  'underscore',
  'settings',
  'app',
  'template!pimSearchTpl',
  'multiSelectDropdownView',
  'entities/caccounts/share'
], function (
  module,
  Marionette,
  $,
  _,
  Settings,
  App,
  viewTpl,
  MultiSelectDropdown
) {
  'use strict';

  var PimSearchView = Marionette.LayoutView.extend({
    template: viewTpl,

    ui: {
      input: '.js-search-input',
      button: '.js-search-btn',
      supplierRegion: '.js-supplier-region',
      results: '.js-results',
      empty: '.js-empty',
      error: '.js-error',
      loader: '.js-loader'
    },

    events: {
      'click @ui.button': 'onSearchClick',
      'keyup @ui.input': 'onInputKeyup',
      // Replace double-click on card with explicit action buttons
      'click .js-info-btn': 'onInfoClick',
      'click .js-compare-btn': 'onCompareToggle',
      'click .js-compare-clear': 'onCompareClear',
      'click .js-compare-open': 'onCompareOpen',
      'click .js-compare-tray-thumb-remove': 'onCompareTrayRemove'
    },

    COMPARE_STORAGE_KEY: 'pim:compare:ids',
    COMPARE_MAX: 4,

    initialize: function () {
      this.results = [];
      this.loading = false;
      this.loadingMore = false;
      this.error = null;
      this.term = '';
      this.supplierSecIds = [];
      this.suppliers = [];
      this.first = 0;
      this.pageSize = 24;
      this.hasMore = false;
      this._boundOnScroll = null;
      this.compareIds = this._readCompareIds();
      this.compareSnapshots = this._readCompareSnapshots();
    },

    _loadSuppliers: function () {
      var that = this;
      App.request('caccounts:get-share-from-sorted').done(function (list) {
        that.suppliers = _.map(list || [], function (s) {
          return {
            value: s.caccountFrom && s.caccountFrom.secId,
            label: s.caccountFrom && s.caccountFrom.code
          };
        });
        if (that._supplierDropdown) {
          that._supplierDropdown.setItems(that.suppliers);
        }
      });
    },

    _mountSupplierDropdown: function () {
      if (!this.ui.supplierRegion || !this.ui.supplierRegion.length) { return; }
      var that = this;
      if (!this._supplierDropdown) {
        this._supplierDropdown = new MultiSelectDropdown({
          items: this.suppliers || [],
          selection: this.supplierSecIds || [],
          placeholder: _.i18n('common.allSuppliers', null, 'All suppliers'),
          countLabel: _.i18n('common.suppliers', null, 'suppliers'),
          clearLabel: _.i18n('common.clear', null, 'Clear'),
          applyLabel: _.i18n('common.validate', null, 'Validate'),
          loadingLabel: _.i18n('common.loading', null, 'Loading...'),
          onApply: function (picked) {
            that.supplierSecIds = picked;
            that.search();
          }
        }).render();
      } else {
        // Keep dropdown in sync with current committed selection after re-renders
        this._supplierDropdown.setSelection(this.supplierSecIds || []);
      }
      if (!$.contains(document.body, this._supplierDropdown.el)) {
        this.ui.supplierRegion.empty().append(this._supplierDropdown.el);
      }
    },

    onShow: function () {
      // attach throttled scroll handler for infinite scroll (window or inner container)
      var that = this;
      this._scrollContainer = $('#content-region');
      if (!this._scrollContainer || !this._scrollContainer.length) {
        this._scrollContainer = $(window);
      }
      this._boundOnScroll = _.throttle(function () {
        that._handleScroll();
      }, 150);
      $(window).on('resize.pimsearch', this._boundOnScroll);
      // bind scroll on chosen container
      this._scrollContainer.on('scroll.pimsearch', this._boundOnScroll);

      this._loadSuppliers();

      // Initialize from URL query (?q=...&s=...) so refresh/back restores search
      try {
        var hash = window.location.hash || '';
        // Expect formats like #/pim/search?q=term or #pim/search?q=term
        var qMatch = hash.match(/^[#\/]*pim\/search(?:\?([^#]*))?/);
        var shouldFetch = false;
        if (qMatch && qMatch[1]) {
          var params = qMatch[1].split('&');
          for (var i = 0; i < params.length; i++) {
            var kv = params[i].split('=');
            if (kv[0] === 'q') {
              var q = decodeURIComponent((kv[1] || '').replace(/\+/g, ' '));
              if (q) {
                this.term = q;
                if (this.ui && this.ui.input) { this.ui.input.val(q); }
                shouldFetch = true;
              }
            } else if (kv[0] === 's') {
              var s = decodeURIComponent((kv[1] || '').replace(/\+/g, ' '));
              if (s) {
                this.supplierSecIds = _.filter(s.split(','), function (v) { return !!v; });
                shouldFetch = true;
              }
            }
          }
        }
        if (shouldFetch) {
          this.results = [];
          this.error = null;
          this.first = 0;
          this.hasMore = true;
          this._fetchPage(true);
        }
      } catch (e) { /* no-op */ }
    },

    onDestroy: function () {
      if (this._supplierDropdown) {
        try { this._supplierDropdown.destroy(); } catch (eSup) {}
        this._supplierDropdown = null;
      }
      try { $(window).off('resize.pimsearch', this._boundOnScroll); } catch (e) {}
      try { if (this._scrollContainer) { this._scrollContainer.off('scroll.pimsearch', this._boundOnScroll); } } catch (e2) {}
      this._boundOnScroll = null;
      // Unbind tooltip scroll/resize listeners
      try { $(window).off('scroll.pimsearchTip resize.pimsearchTip'); } catch (e0) {}
      try { $(document).off('click.pimsearchTip keydown.pimsearchTip'); } catch (eDoc) {}
      if (this._tooltipContainer) {
        try { this._tooltipContainer.off('scroll.pimsearchTip'); } catch (e1) {}
      }
      // Destroy any active popover/anchor
      try {
        if (this._activePopover && this._activePopover.anchor) {
          this._activePopover.anchor.popover('destroy');
          this._activePopover.anchor.remove();
        }
      } catch (e2) {}
      this._activePopover = null;
      try { this.$('.js-result-card').popover('destroy'); } catch (e3) {}
    },

    serializeData: function () {
      return {
        results: this.results || [],
        loading: this.loading,
        loadingMore: this.loadingMore,
        error: this.error,
        hasResults: (this.results && this.results.length > 0),
        hasMore: this.hasMore,
        term: this.term || '',
        suppliers: this.suppliers || [],
        supplierSecIds: this.supplierSecIds || [],
        compareIds: this.compareIds || [],
        compareMax: this.COMPARE_MAX
      };
    },

    onBeforeRender: function () {
      // Detach the supplier dropdown before jQuery.html() wipes its event
      // handlers via cleanData on descendants. _mountSupplierDropdown will
      // re-append it in onRender with bindings intact.
      if (this._supplierDropdown && this._supplierDropdown.$el) {
        try { this._supplierDropdown.$el.detach(); } catch (e) {}
      }
    },

    onRender: function () {
      // Loader: show only for initial load (no results yet)
      if (this.loading && !(this.results && this.results.length)) {
        this.ui.loader.show();
      } else {
        this.ui.loader.hide();
      }
      // Error
      if (this.error) {
        this.ui.error.text(this.error).show();
      } else {
        this.ui.error.hide().text('');
      }
      // Empty state
      if (!this.loading && !this.error && (!this.results || this.results.length === 0)) {
        this.ui.empty.show();
      } else {
        this.ui.empty.hide();
      }
      // Reflect current term in the input field
      if (this.ui && this.ui.input) {
        this.ui.input.val(this.term || '');
      }
      // (Re-)mount the supplier multi-select dropdown
      this._mountSupplierDropdown();
      // Initialize hover tooltips on cards
      this._initPopovers();
      // Re-cache thumbnails for any basket item that appears in current results,
      // then refresh the floating compare tray.
      this._refreshCompareSnapshotsFromResults();
      this._renderCompareTray();
    },

    onInputKeyup: function (e) {
      if (e.key === 'Enter') {
        this.search();
      }
    },

    onSearchClick: function () {
      this.search();
    },

    // Note: "Open" action is now a normal anchor link in the template so users can open in new tab

    // Click handler for the "Info" button to show tooltip/popover
    onInfoClick: function (e) {
      try {
        e.preventDefault();
        e.stopPropagation();
      } catch (ex) {}
      try {
        var $btn = $(e.currentTarget);
        var $card = $btn.closest('.js-result-card');
        if (!$card.length) { return; }
        if (this._activePopover && this._activePopover.card && this._activePopover.card[0] === $card[0]) {
          // If already visible for this card, hide it
          if (this._hideActiveTooltip) { this._hideActiveTooltip(); }
          return;
        }
        if (this._showTooltipForCard) {
          this._showTooltipForCard($card, e);
        }
      } catch (err) {}
    },

    _handleScroll: function () {
      if (!this.hasMore || this.loading) { return; }
      var threshold = 200;
      // If scrolling on window
      if (!this._scrollContainer || this._scrollContainer[0] === window) {
        var scrollTop = $(window).scrollTop();
        var winH = $(window).height();
        var docH = $(document).height();
        if (scrollTop + winH >= docH - threshold) {
          this._fetchPage();
        }
        return;
      }
      // Else, element container
      var el = this._scrollContainer[0];
      var scrollTopEl = el.scrollTop;
      var clientH = el.clientHeight;
      var scrollH = el.scrollHeight;
      if (scrollTopEl + clientH >= scrollH - threshold) {
        this._fetchPage();
      }
    },

    // After rendering results, if the list doesn't fill the viewport/scroll container,
    // fetch additional pages up to a small limit to give a seamless lazy-load experience.
    _maybeAutofill: function () {
      if (!this.hasMore || this.loading) { return; }
      this._autofillTries = this._autofillTries || 0;
      var threshold = 200;
      var needMore = false;
      if (!this._scrollContainer || this._scrollContainer[0] === window) {
        var winBottom = $(window).scrollTop() + $(window).height();
        var docH = $(document).height();
        needMore = (docH - winBottom) < threshold;
      } else {
        var el = this._scrollContainer[0];
        needMore = (el.scrollHeight - (el.scrollTop + el.clientHeight)) < threshold;
      }
      if (needMore && this.hasMore && !this.loading && this._autofillTries < 3) {
        this._autofillTries++;
        this._fetchPage();
      }
    },

    search: function () {
      var term = (this.ui.input.val() || '').trim();
      this.term = term;
      this._autofillTries = 0;

      // Update the URL so back/refresh restores the search
      try {
        var qs = [];
        if (term) { qs.push('q=' + encodeURIComponent(term)); }
        if (this.supplierSecIds && this.supplierSecIds.length) {
          qs.push('s=' + encodeURIComponent(this.supplierSecIds.join(',')));
        }
        var frag = 'pim/search' + (qs.length ? ('?' + qs.join('&')) : '');
        App.navigate(frag, {trigger: false, replace: false});
      } catch (e) { /* no-op */ }

      if (!term && !(this.supplierSecIds && this.supplierSecIds.length)) {
        this.results = [];
        this.error = null;
        this.loading = false;
        this.hasMore = false;
        this.first = 0;
        this.render();
        return;
      }
      // reset paging and fetch first page
      this.results = [];
      this.error = null;
      this.first = 0;
      this.hasMore = true;
      this.loadingMore = false;
      this._fetchPage(true);
    },

    _fetchPage: function (isFirstPage) {
      if (this.loading || !this.hasMore) { return; }
      var params = {
        lang: 'en',
        tokenId: Settings.get('webshopApiTokenId'),
        pageSize: this.pageSize,
        first: this.first,
        productName: this.term
      };
      if (this.supplierSecIds && this.supplierSecIds.length) {
        params.supplierSecId = this.supplierSecIds.join(',');
      }
      var url = Settings.url('compuzz2', 'v2/pim/products', params);
      var that = this;
      // If we already have results, show loader as a trailing grid item
      this.loadingMore = !!(this.results && this.results.length);
      this.loading = true;
      this.error = null;
      this.render();
      $.ajax({
        type: 'GET',
        url: url,
        success: function (data) {
          var mapped = that._mapResults(data || []);
          if (isFirstPage) {
            that.results = mapped;
          } else {
            that.results = (that.results || []).concat(mapped);
          }
          var received = mapped.length;
          that.first += received;
          that.hasMore = received >= that.pageSize;
          that.loading = false;
          that.loadingMore = false;
          that.error = null;
          that.render();
          // Try to auto-fill if content doesn't reach bottom yet
          try { that._maybeAutofill(); } catch (e0) { /* no-op */ }
          // After rendering basic results, fetch stocks asynchronously for newly added items
          try { that._fetchStocksForResults(mapped); } catch (e) { /* no-op */ }
        },
        error: function () {
          that.loading = false;
          that.loadingMore = false;
          that.error = _.i18n ? _.i18n('common.error', null, 'Error') : 'Error';
          that.hasMore = false;
          that.render();
        }
      });
    },

    _getImage: function (item) {
      // Prefer resellerData[0].catalogPictureUid if present, otherwise data.catalogPictureUrl, else notFound
      try {
        if (item && item.resellerData && item.resellerData.length > 0) {
          var uid = item.resellerData[0].catalogPictureUid;
          if (uid) {
            return Settings.url('file', uid) + '&cmds=on';
          }
        }
      } catch (e) {}
      if (item && item.data && item.data.catalogPictureUrl) {
        return item.data.catalogPictureUrl;
      }
      return Settings.get('notFoundImage');
    },

    _getTrans: function (val) {
      if (!val) { return ''; }
      if (typeof val === 'string') { return val; }
      if (val.values) {
        if (Settings.get('lang') && val.values[Settings.get('lang')]) { return val.values[Settings.get('lang')]; }
        return val.values.en || _.values(val.values)[0] || '';
      }
      return '';
    },

    _extractColors: function (p) {
      var colors = [];
      var added = {};
      var cats = p && p.data && p.data.productOptionCategories ? p.data.productOptionCategories : [];

      function getColorFromColor1(c) {
        if (!c) { return ''; }
        if (typeof c === 'string') { return c; }
        if (typeof c === 'object') {
          if (c.hex) { return c.hex; }
          if (c.hexa) { return c.hexa; }
          if (c.colorHex) { return c.colorHex; }
          if (typeof c.rgb === 'string') { return c.rgb; }
          var r = (c.r !== undefined) ? c.r : (c.red !== undefined ? c.red : null);
          var g = (c.g !== undefined) ? c.g : (c.green !== undefined ? c.green : null);
          var b = (c.b !== undefined) ? c.b : (c.blue !== undefined ? c.blue : null);
          if (r !== null && g !== null && b !== null) { return 'rgb(' + r + ',' + g + ',' + b + ')'; }
        }
        return '';
      }

      // Prefer categories explicitly typed as color
      var colorCats = [];
      for (var x = 0; x < cats.length; x++) {
        var ccat = cats[x];
        if (ccat && ccat.displayType && (('' + ccat.displayType).toLowerCase() === 'color')) {
          colorCats.push(ccat);
        }
      }

      for (var i = 0; i < colorCats.length; i++) {
        var cat = colorCats[i];
        var opts = cat.productOptions || [];
        for (var j = 0; j < opts.length; j++) {
          var opt = opts[j];
          var label = this._getTrans(opt.name) || opt.name || '';
          // Per requirement, take color from product option's color1
          var val = getColorFromColor1(opt.color1) || '';
          var key = (val || label).toLowerCase();
          if (!added[key]) {
            colors.push({ value: val, label: label });
            added[key] = true;
          }
          if (colors.length >= 20) { break; }
        }
        if (colors.length >= 20) { break; }
      }
      return colors;
    },

    _mapResults: function (list) {
      var that = this;
      return _.map(list, function (p) {
        // product code from resellerData[0].code or data.code
        var productCode = (p.resellerData && p.resellerData[0] && p.resellerData[0].code) || (p.data && p.data.code) || '';
        var supplierProductCode = (p.data && p.data.code) || '';
        var supplierName = p.supplier || '';
        var productName = '';
        var description = '';
        var fastDelivery = false;
        try {
          productName = that._getTrans(p.data && p.data.name);
        } catch (e) { productName = ''; }
        try {
          description = that._getTrans(p.data && p.data.description);
        } catch (e2) { description = ''; }
        try {
          fastDelivery = !!(p.data && p.data.fastDelivery);
        } catch (e3) { fastDelivery = false; }
        var colors = that._extractColors(p);
        var areas = that._extractPrintAreas(p);
        var printAreasSummary = that._formatAreasSummary(areas);
        var optionsSummary = that._formatOptionsSummaryFromProduct(p);
        var techniquesSummary = that._formatTechniquesSummary(that._extractPrintTechniquesFromProduct(p));
        var colorImages = that._extractColorImages(p);
        // Extract stats for offers/orders and compute conversion rate
        var nbrOffer = null, nbrOrder = null, conversionRate = null;
        try {
          var s = p && p.stats ? p.stats : null;
          if (s) {
            // Normalize to numbers when possible
            if (s.nbrOffer !== undefined && s.nbrOffer !== null && s.nbrOffer !== '') {
              nbrOffer = typeof s.nbrOffer === 'number' ? s.nbrOffer : parseFloat(s.nbrOffer);
              if (isNaN(nbrOffer)) nbrOffer = null;
            }
            if (s.nbrOrder !== undefined && s.nbrOrder !== null && s.nbrOrder !== '') {
              nbrOrder = typeof s.nbrOrder === 'number' ? s.nbrOrder : parseFloat(s.nbrOrder);
              if (isNaN(nbrOrder)) nbrOrder = null;
            }
            if (nbrOffer && nbrOffer > 0 && nbrOrder !== null && nbrOrder !== undefined) {
              conversionRate = (nbrOrder / nbrOffer) * 100; // percentage
            } else if (nbrOffer === 0) {
              conversionRate = 0;
            }
          }
        } catch (eStats) { /* no-op */ }

        return {
          id: p.id,
          resellerProductId: (p.resellerData && p.resellerData[0] && p.resellerData[0].id) || null,
          img: that._getImage(p),
          productCode: productCode,
          supplierProductCode: supplierProductCode,
          supplierName: supplierName,
          productName: productName,
          description: description,
          fastDelivery: fastDelivery,
          // Attempt to detect deprecated status from various possible fields
          deprecated: p.outDated,
          colors: colors,
          printAreasSummary: printAreasSummary,
          optionsSummary: optionsSummary,
          techniquesSummary: techniquesSummary,
          colorImages: colorImages,
          // Stats
          nbrOffer: nbrOffer,
          nbrOrder: nbrOrder,
          conversionRate: conversionRate,
          // Stock (loaded later)
          stockQty: null,
          stockDetails: null,
          stockLoaded: false
        };
      });
    },

    _findItem: function (id) {
      var res = null;
      var key = String(id);
      for (var i = 0; i < (this.results || []).length; i++) {
        if (String(this.results[i].id) === key) { res = this.results[i]; break; }
      }
      return res;
    },

    _escape: function (str) {
      if (!str && str !== 0) { return ''; }
      return String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    },

    _truncate: function (str, max) {
      if (!str) { return ''; }
      if (str.length <= max) { return str; }
      return str.substr(0, max - 1) + '…';
    },

    // Build a concise list of print areas with example technologies
    _extractPrintAreas: function (p) {
      var areas = [];
      try {
        var pas = p && p.data && p.data.printAreas ? p.data.printAreas : [];
        for (var i = 0; i < pas.length; i++) {
          var pa = pas[i];
          var name = this._getTrans(pa && pa.name) || '';
          var techs = [];
          var seen = {};
          var pzs = (pa && pa.printZones) || [];
          for (var j = 0; j < pzs.length; j++) {
            var pz = pzs[j];
            var tname = this._getTrans(pz && pz.refImprintTechnology && pz.refImprintTechnology.name) || '';
            if (tname) {
              var key = tname.toLowerCase();
              if (!seen[key]) { seen[key] = true; techs.push(tname); }
            }
          }
          if (name) {
            areas.push({ name: name, techs: techs });
          }
          if (areas.length >= 10) { break; }
        }
      } catch (e) { /* no-op */ }
      return areas;
    },

    _formatAreasSummary: function (areas) {
      if (!areas || !areas.length) { return ''; }
      var names = [];
      for (var i = 0; i < areas.length; i++) {
        names.push(areas[i].name);
        if (names.length >= 3) { break; }
      }
      var extra = areas.length - names.length;
      var summary = names.join(', ');
      if (extra > 0) { summary += ' (+' + extra + ')'; }
      return summary;
    },

    // Build a compact options summary based on product option categories
    _formatOptionsSummaryFromProduct: function (p) {
      try {
        var cats = p && p.data && p.data.productOptionCategories ? p.data.productOptionCategories : [];
        if (!cats || !cats.length) { return ''; }
        var names = [];
        for (var i = 0; i < cats.length; i++) {
          var cname = this._getTrans(cats[i].name) || '';
          if (cname) { names.push(cname); }
          if (names.length >= 3) { break; }
        }
        var extra = (cats.length || 0) - (names.length || 0);
        var summary = names.join(', ');
        if (extra > 0) { summary += ' (+' + extra + ')'; }
        return summary;
      } catch (e) { return ''; }
    },

    // Extract and dedupe print techniques across all print zones
    _extractPrintTechniquesFromProduct: function (p) {
      var list = [];
      var seen = {};
      try {
        var pas = p && p.data && p.data.printAreas ? p.data.printAreas : [];
        for (var i = 0; i < pas.length; i++) {
          var pzs = (pas[i] && pas[i].printZones) || [];
          for (var j = 0; j < pzs.length; j++) {
            var name = this._getTrans(pzs[j] && pzs[j].refImprintTechnology && pzs[j].refImprintTechnology.name) || '';
            if (!name) { continue; }
            var key = name.toLowerCase();
            if (!seen[key]) { seen[key] = true; list.push(name); }
            if (list.length >= 12) { break; }
          }
          if (list.length >= 12) { break; }
        }
      } catch (e) { /* no-op */ }
      return list;
    },

    _formatTechniquesSummary: function (techs) {
      if (!techs || !techs.length) { return ''; }
      var max = 4;
      var shown = techs.slice(0, max);
      var extra = techs.length - shown.length;
      var summary = shown.join(', ');
      if (extra > 0) { summary += ' (+' + extra + ')'; }
      return summary;
    },

    // Build image per color using product option picture1 when available; fallback to variations/images
    _extractColorImages: function (p) {
      var results = [];
      var seen = {};
      try {
        var data = p && p.data ? p.data : {};
        var cats = data.productOptionCategories || [];

        // 1) Prefer categories that are typed/displayed as color
        var colorCats = [];
        for (var ci = 0; ci < cats.length; ci++) {
          var cat = cats[ci] || {};
          var t = (cat.type || cat.displayType || '').toString().toLowerCase();
          if (t === 'color') { colorCats.push(cat); }
        }

        // If we have explicit color categories, use their productOptions.picture1
        for (var i = 0; i < colorCats.length; i++) {
          var opts = colorCats[i].productOptions || [];
          for (var j = 0; j < opts.length; j++) {
            var opt = opts[j] || {};
            var label = this._getTrans(opt.name) || opt.name || '';
            var colorValue = '';
            // derive color value from color1 when possible (already used in dots)
            var c = opt.color1;
            if (typeof c === 'string') { colorValue = c; }
            else if (typeof c === 'object' && c) {
              colorValue = c.hex || c.hexa || c.colorHex || (typeof c.rgb === 'string' ? c.rgb : '');
              if (!colorValue && (c.r !== undefined && c.g !== undefined && c.b !== undefined)) {
                colorValue = 'rgb(' + c.r + ',' + c.g + ',' + c.b + ')';
              }
            }

            var key = (colorValue || label || (opt.pimId || opt.id || '')).toString().toLowerCase();
            if (seen[key]) { continue; }

            var imgUrl = '';
            var pic = opt.picture1 || opt.image1 || opt.image || '';
            if (pic) {
              if (typeof pic === 'string' && pic.indexOf('http') === 0) {
                imgUrl = pic;
              } else {
                // treat as UID
                imgUrl = Settings.url('file', pic) + '&cmds=on';
              }
            }
            if (!imgUrl) { imgUrl = this._getImage(p); }

            results.push({ label: label, value: colorValue, img: imgUrl });
            seen[key] = true;
            if (results.length >= 12) { break; }
          }
          if (results.length >= 12) { break; }
        }

        if (results.length) { return results; }

        // 2) Fallback: use first image from each variation having a color option
        var vars = data.productCodeVariations || [];
        for (var vIdx = 0; vIdx < vars.length; vIdx++) {
          var v = vars[vIdx] || {};
          var vOpts = v.productOptions || [];
          var colorLabel = '';
          var colorVal = '';
          for (var k = 0; k < vOpts.length; k++) {
            var vopt = vOpts[k] || {};
            if (vopt && (vopt.color1 !== undefined && vopt.color1 !== null)) {
              colorLabel = this._getTrans(vopt.name) || vopt.name || '';
              var vc = vopt.color1;
              if (typeof vc === 'string') { colorVal = vc; }
              else if (typeof vc === 'object' && vc) {
                colorVal = vc.hex || vc.hexa || vc.colorHex || (typeof vc.rgb === 'string' ? vc.rgb : '');
                if (!colorVal && (vc.r !== undefined && vc.g !== undefined && vc.b !== undefined)) {
                  colorVal = 'rgb(' + vc.r + ',' + vc.g + ',' + vc.b + ')';
                }
              }
              break;
            }
          }
          if (!colorLabel && !colorVal) { continue; }
          var vKey = (colorVal || colorLabel).toLowerCase();
          if (seen[vKey]) { continue; }

          var vImg = '';
          try {
            if (v.images && v.images.length) {
              var img0 = v.images[0];
              var uid = (img0 && (img0.uid || img0.secId || img0.id || img0.url || img0.imageUrl || img0.href)) || v.imageUid || v.imageId;
              if (uid && typeof uid === 'string' && uid.indexOf('http') === 0) {
                vImg = uid;
              } else if (uid) {
                vImg = Settings.url('file', uid) + '&cmds=on';
              }
            }
          } catch (e2) { /* no-op */ }
          if (!vImg) { vImg = this._getImage(p); }

          results.push({ label: colorLabel, value: colorVal, img: vImg });
          seen[vKey] = true;
          if (results.length >= 12) { break; }
        }
      } catch (e) { /* no-op */ }
      return results;
    },

    // Fetch stocks for a batch of result items; computes total currentQuantity per reseller product
    _fetchStocksForResults: function (items) {
      var that = this;
      if (!items || !items.length) { return; }
      // Limit number of concurrent requests to avoid overloading server
      var queue = [];
      for (var i = 0; i < items.length; i++) {
        var it = items[i];
        if (!it) { continue; }
        if (it.stockLoaded) { continue; }
        if (!it.resellerProductId) { it.stockLoaded = true; continue; }
        queue.push(it);
      }
      if (!queue.length) { return; }

      // Process sequentially to keep it simple and safe
      var idx = 0;
      var changed = false;
      function next() {
        if (idx >= queue.length) {
          if (changed) {
            try { that.render(); that._initPopovers(); } catch (e) {}
          }
          return;
        }
        var item = queue[idx++];
        item.stockLoaded = true; // mark to avoid duplicate fetches
        var url = Settings.url('compuzz2', 'v2/pim/products/resellerProduct/' + item.resellerProductId + '/stocks');
        $.ajax({
          type: 'GET',
          url: url,
          success: function (data) {
            try {
              var sum = 0;
              if (Array.isArray(data)) {
                for (var j = 0; j < data.length; j++) {
                  var s = data[j];
                  var q = s && (s.currentQuantity !== null ? s.currentQuantity : s.quantity);
                  if (typeof q === 'string') { q = parseFloat(q); }
                  if (typeof q === 'number' && !isNaN(q)) { sum += q; }
                }
              }
              item.stockQty = sum;
              item.stockDetails = Array.isArray(data) ? data : [];
              changed = true;
            } catch (e) { /* no-op */ }
            next();
          },
          error: function () { next(); }
        });
      }
      next();
    },

    _buildTooltip: function (item) {
      if (!item) { return ''; }
      var name = this._escape(item.productName || '');
      var supplier = this._escape(item.supplierName || '');
      var pcode = this._escape(item.productCode || '');
      var scode = this._escape(item.supplierProductCode || '');
      var desc = this._escape(this._truncate(item.description || '', 180));
      var img = this._escape(item.img || '');
      var fd = item.fastDelivery ? '<span class="label label-success" style="margin-left:6px;">'+(_.i18n?_.i18n('common.fastDelivery', null, 'Fast delivery'):'Fast delivery')+'</span>' : '';
      var dp = item.deprecated ? '<span class="label label-warning" style="margin-left:6px;" title="Deprecated">'+('Deprecated')+'</span>' : '';
      var colorDots = '';
      if (item.colors && item.colors.length) {
        var maxDots = Math.min(item.colors.length, 10);
        for (var i = 0; i < maxDots; i++) {
          var c = item.colors[i];
          var fill = c && c.value ? this._escape(c.value) : 'transparent';
          var title = c && c.label ? this._escape(c.label) : '';
          colorDots += '<span title="'+title+'" style="display:inline-block;width:12px;height:12px;border-radius:50%;border:1px solid rgba(0,0,0,0.2);background:'+fill+';margin-right:4px;"></span>';
        }
        var extra = item.colors.length - maxDots;
        if (extra > 0) {
          colorDots += '<span style="font-size:11px;color:#667085;">+'+extra+'</span>';
        }
      }
      var html = '' +
        '<div class="pim-search-popover">' +
        ' <div style="display:flex;gap:14px;align-items:flex-start;max-width:640px;">' +
        '   <div style="flex:0 0 140px;height:140px;border:1px solid #e0e3e8;background:#f9fafb;display:flex;align-items:center;justify-content:center;overflow:hidden;border-radius:8px;">' +
        '     <img src="'+img+'" alt="" style="max-width:100%;max-height:100%;object-fit:contain;display:block;" />' +
        '   </div>' +
        '   <div style="flex:1 1 auto;min-width:0;">' +
        '     <div style="font-weight:700;color:#1a1a2e;margin-bottom:2px;">'+name+fd+dp+'</div>' +
        (supplier ? ('     <div style="color:#667085;font-size:12px;margin-bottom:4px;">'+supplier+'</div>') : '') +
        '     <div style="font-size:12px;color:#344054;margin-bottom:2px;"><span style="color:#667085;">'+(_.i18n?_.i18n('productList.productCode', null, 'Product code'):'Product code')+':</span> '+pcode+'</div>' +
        '     <div style="font-size:12px;color:#344054;margin-bottom:4px;"><span style="color:#667085;">'+(_.i18n?_.i18n('productList.productCodeMan', null, 'Supplier code'):'Supplier code')+':</span> '+scode+'</div>' +
        (desc ? ('     <div style="font-size:12px;color:#344054;line-height:1.3;max-width:560px;">'+desc+'</div>') : '') +
        (colorDots ? ('     <div style="margin-top:6px;">'+colorDots+'</div>') : '') +
        (item.printAreasSummary ? ('     <div style="font-size:12px;color:#344054;margin-top:6px;"><span style="color:#667085;">'+('Print areas')+':</span> '+this._escape(item.printAreasSummary)+'</div>') : '') +
        (item.optionsSummary ? ('     <div style="font-size:12px;color:#344054;margin-top:2px;"><span style="color:#667085;">'+('Options')+':</span> '+this._escape(item.optionsSummary)+'</div>') : '') +
        (item.techniquesSummary ? ('     <div style="font-size:12px;color:#344054;margin-top:2px;"><span style="color:#667085;">'+('Techniques')+':</span> '+this._escape(item.techniquesSummary)+'</div>') : '') +
        (function(){
            var html = '';
            try {
              if (item.stockQty !== null) {
                html += '     <div style="font-size:12px;color:#344054;margin-top:6px;"><span style="color:#667085;">'+('Stock')+':</span> '+String(item.stockQty)+'</div>';
              }
              if (item.stockDetails && item.stockDetails.length) {
                html += '     <div style="margin-top:4px;">'+
                        '       <div style="font-size:11px;color:#667085;margin-bottom:2px;">'+('Stock details')+':</div>'+
                        '       <ul style="margin:0;padding-left:16px;max-width:380px;">';
                var max = Math.min(item.stockDetails.length, 4);
                for (var i = 0; i < max; i++) {
                  var st = item.stockDetails[i] || {};
                  // Build a human-readable label from product options; fallback to variation code
                  var optLabel = st.productOptions;
                  if (!optLabel) { optLabel = st.code || ''; }
                  optLabel = this._escape(optLabel);
                  var qty = st.currentQuantity;
                  if (typeof qty === 'string') { qty = parseFloat(qty); }
                  if (qty === null || isNaN(qty)) { qty = 0; }
                  var na = st.newArrivalQuantity;
                  if (typeof na === 'string') { na = parseFloat(na); }
                  var eta = st.newArrivalETA ? this._escape(String(st.newArrivalETA)) : '';
                  html += '         <li style="font-size:12px;color:#344054;">'+ (optLabel ? (optLabel+': ') : '') + qty + (na ? (' <span style="color:#667085;">(+ '+ na + (eta ? (' ETA '+ eta) : '') + ')</span>') : '') +'</li>';
                }
                var extra = item.stockDetails.length - max;
                if (extra > 0) {
                  html += '       <li style="font-size:11px;color:#667085;">+'+extra+' more…</li>';
                }
                html += '       </ul>\n     </div>';
              }
            } catch (e) {}
            return html;
          }).call(this) +
        (item.colorImages && item.colorImages.length ? (function(){
            var html = '     <div style="margin-top:8px;">'+
                        '       <div style="font-size:12px;color:#667085;margin-bottom:4px;">'+('Images per color')+':</div>'+
                        '       <div style="display:flex;flex-wrap:wrap;gap:8px;max-width:560px;">';
            var max = Math.min(item.colorImages.length, 8);
            for (var i = 0; i < max; i++) {
              var ci = item.colorImages[i];
              var lbl = ci.label ? ci.label.replace(/"/g,'&quot;') : '';
              var img = ci.img ? ci.img.replace(/"/g,'&quot;') : '';
              html += '         <span title="'+lbl+'" style="display:inline-flex;align-items:center;gap:4px;">'+
                      '           <span style="width:40px;height:40px;border-radius:8px;overflow:hidden;border:1px solid #e0e3e8;background:#f9fafb;display:inline-flex;align-items:center;justify-content:center;">'+ 
                      '             <img src="'+img+'" alt="" style="width:100%;height:100%;object-fit:cover;display:block;" loading="lazy" decoding="async" />'+
                      '           </span>'+ (ci.label ? '<span style="font-size:11px;color:#667085;max-width:90px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">'+lbl+'</span>' : '') +
                      '         </span>';
            }
            var extra = item.colorImages.length - max;
            if (extra > 0) {
              html += '       <span style="font-size:11px;color:#667085;align-self:center;">+'+extra+'</span>';
            }
            html += '       </div>\n     </div>';
            return html;
          })() : '') +
        '   </div>' +
        ' </div>' +
        '</div>';
      return html;
    },

    _initPopovers: function () {
      var that = this;
      // Remove old listeners and popovers
      try { this.$('.js-result-card').off('.pimsearch'); } catch (e) {}
      try {
        if (this._activePopover && this._activePopover.anchor) {
          this._activePopover.anchor.popover('destroy');
          this._activePopover.anchor.remove();
        }
      } catch (e2) {}
      this._activePopover = null;

      if (!this.results || !this.results.length || this.loading) { return; }

      var $container = $('body');
      this._tooltipContainer = $container;
      var scrollRAF = null;
      this._lastMouse = this._lastMouse || null;

      // Helper to position the current popover near the mouse (evt optional)
      this._updateTooltipPosition = function (evt) {
        if (!that._activePopover || !that._activePopover.anchor) { return; }
        var pop = that._activePopover.anchor.data('bs.popover');
        var $tip = pop && pop.tip ? pop.tip() : null;
        if (!$tip || !$tip.length) { return; }

        // Position relative to the SCREEN (viewport), not any container
        var clientX, clientY;
        if (evt && (evt.clientX && evt.clientY)) {
          clientX = evt.clientX; clientY = evt.clientY;
        } else if (that._lastMouse && (that._lastMouse.clientX && that._lastMouse.clientY)) {
          clientX = that._lastMouse.clientX; clientY = that._lastMouse.clientY;
        } else if (that._activePopover.card && that._activePopover.card.length) {
          var off = that._activePopover.card[0].getBoundingClientRect();
          clientX = off.left + (off.width || 0) / 2;
          clientY = off.top + (off.height || 0) / 2;
        } else {
          clientX = 16; clientY = 16;
        }

        // Viewport size
        var cw = $(window).width();
        var ch = $(window).height();
        var tw = $tip.outerWidth() || 240;
        var th = $tip.outerHeight() || 140;

        var margin = 6;
        // Candidate positions relative to viewport
        var xRight = clientX + margin;
        var xLeft = clientX - tw - margin;
        var yBottom = clientY + margin;
        var yTop = clientY - th - margin;

        var placeLeft = (xRight + tw > cw - 8) && (xLeft >= 8);
        var placeTop = (yBottom + th > ch - 8) && (yTop >= 8);

        var x = placeLeft ? Math.max(8, xLeft) : Math.max(8, Math.min(xRight, cw - tw - 8));
        var y = placeTop ? Math.max(8, yTop) : Math.max(8, Math.min(yBottom, ch - th - 8));

        // Use fixed positioning so it stays relative to the viewport
        $tip.css({position: 'fixed', left: x + 'px', top: y + 'px'});
      };

      // Helper to hide any active tooltip
      this._hideActiveTooltip = function () {
        try {
          if (that._activePopover && that._activePopover.anchor) {
            that._activePopover.anchor.popover('destroy');
            that._activePopover.anchor.remove();
          }
        } catch (e) {}
        try { $('.popover').remove(); } catch (e2) {}
        that._activePopover = null;
      };

      // Helper to show tooltip for a card at mouse position
      this._showTooltipForCard = function ($card, evt) {
        // Hide other tooltips first
        that._hideActiveTooltip();

        var id = $card.data('product-id');
        var item = that._findItem(id);
        var content = that._buildTooltip(item);
        if (!content) { return; }

        var $anchor = $('<div class="pim-search-popover-anchor" style="position:absolute;left:-9999px;top:-9999px;width:1px;height:1px;pointer-events:none;"></div>');
        $container.append($anchor);
        $anchor.popover({
          trigger: 'manual',
          placement: 'auto',
          html: true,
          container: 'body',
          content: content
        });
        $anchor.popover('show');
        try {
          var tip = $anchor.data('bs.popover') && $anchor.data('bs.popover').tip ? $anchor.data('bs.popover').tip() : null;
          if (tip && tip.length) {
            // Ensure tooltip does not intercept mouse and has a white background
            tip.css({
              'pointer-events': 'none',
              'position': 'fixed',
              'background': '#fff',
              'background-color': '#fff',
              'border-color': '#e0e3e8',
              'max-width': '640px',
              'width': 'auto'
            });
            try {
              tip.find('.popover-content, .popover-title').css({
                'background':'#fff',
                'background-color':'#fff',
                'max-width': 'none'
              });
            } catch (e) {}
          }
        } catch (e) {}
        that._activePopover = {anchor: $anchor, card: $card};
        // Remember cursor and position initially
        if (evt && (evt.pageX || evt.pageY)) {
          that._lastMouse = {pageX: evt.pageX, pageY: evt.pageY, clientX: evt.clientX, clientY: evt.clientY};
        }
        that._updateTooltipPosition(evt);
      };

      // Note: click binding to Info buttons is handled via Marionette events (onInfoClick)

      // Close on outside click or ESC
      try { $(document).off('click.pimsearchTip keydown.pimsearchTip'); } catch (eDocOff) {}
      $(document).on('click.pimsearchTip', function (e) {
        if (!that._activePopover) { return; }
        var popInst = that._activePopover.anchor && that._activePopover.anchor.data('bs.popover');
        var $tip = popInst && popInst.tip ? popInst.tip() : null;
        var clickedCard = that._activePopover.card && (e.target === that._activePopover.card[0] || $.contains(that._activePopover.card[0], e.target));
        var clickedTip = $tip && $tip.length && (e.target === $tip[0] || $.contains($tip[0], e.target));
        if (!clickedCard && !clickedTip) { that._hideActiveTooltip(); }
      }).on('keydown.pimsearchTip', function (e) {
        var key = e.key || e.keyCode;
        if (key === 'Escape' || key === 27) { that._hideActiveTooltip(); }
      });

      // Reposition on scroll/resize using the card bounds (no mouse tracking needed)
      var onScrollOrResize = function(){
        if (!that._activePopover) { return; }
        // mark as scrolling
        that._isScrolling = true;
        if (that._scrollTimer) { clearTimeout(that._scrollTimer); }
        that._scrollTimer = setTimeout(function(){ that._isScrolling = false; }, 150);
        if (scrollRAF) { cancelAnimationFrame(scrollRAF); }
        scrollRAF = requestAnimationFrame(function(){ that._updateTooltipPosition(); });
      };
      try { $(window).off('scroll.pimsearchTip resize.pimsearchTip'); } catch (e3) {}
      $(window).on('scroll.pimsearchTip resize.pimsearchTip', onScrollOrResize);
      try { $container.off('scroll.pimsearchTip'); } catch (e4) {}
      $container.on('scroll.pimsearchTip', onScrollOrResize);
    },

    // ── Compare basket ─────────────────────────────────────
    //
    // Two parallel stores in localStorage:
    //   COMPARE_STORAGE_KEY      → ['123', '456']             (canonical id list,
    //                                                          also read by the
    //                                                          compare controller)
    //   COMPARE_SNAPSHOT_KEY     → { '123': {name,img,code} } (thumbnails for the
    //                                                          tray; survives a
    //                                                          reload before any
    //                                                          search has run)

    COMPARE_SNAPSHOT_KEY: 'pim:compare:snapshots',

    _readCompareIds: function () {
      try {
        var raw = window.localStorage.getItem(this.COMPARE_STORAGE_KEY);
        if (!raw) { return []; }
        var arr = JSON.parse(raw);
        if (!_.isArray(arr)) { return []; }
        return _.map(arr.slice(0, this.COMPARE_MAX), function (v) { return String(v); });
      } catch (e) { return []; }
    },

    _writeCompareIds: function () {
      try {
        window.localStorage.setItem(this.COMPARE_STORAGE_KEY, JSON.stringify(this.compareIds || []));
      } catch (e) { /* no-op */ }
    },

    _readCompareSnapshots: function () {
      try {
        var raw = window.localStorage.getItem(this.COMPARE_SNAPSHOT_KEY);
        if (!raw) { return {}; }
        var obj = JSON.parse(raw);
        return (obj && typeof obj === 'object') ? obj : {};
      } catch (e) { return {}; }
    },

    _writeCompareSnapshots: function () {
      try {
        window.localStorage.setItem(this.COMPARE_SNAPSHOT_KEY,
          JSON.stringify(this.compareSnapshots || {}));
      } catch (e) { /* no-op */ }
    },

    _snapshotForItem: function (item) {
      if (!item) { return null; }
      return {
        name: item.productName || '',
        code: item.productCode || '',
        img: item.img || ''
      };
    },

    // After every render of the results grid, refresh snapshots for any
    // basket entries that appear in the current results — keeps the cached
    // image/name in sync if the user adds, searches, then reloads.
    _refreshCompareSnapshotsFromResults: function () {
      if (!this.compareIds || !this.compareIds.length) { return; }
      var changed = false;
      var that = this;
      _.each(this.compareIds, function (id) {
        var item = that._findItem(id);
        var snap = that._snapshotForItem(item);
        if (!snap) { return; }
        var prev = that.compareSnapshots[id];
        if (!prev || prev.name !== snap.name || prev.img !== snap.img || prev.code !== snap.code) {
          that.compareSnapshots[id] = snap;
          changed = true;
        }
      });
      if (changed) { this._writeCompareSnapshots(); }
    },

    onCompareToggle: function (e) {
      try { e.preventDefault(); e.stopPropagation(); } catch (ex) {}
      var $btn = $(e.currentTarget);
      var id = String($btn.attr('data-product-id') || '');
      if (!id) { return; }
      var idx = _.indexOf(this.compareIds, id);
      if (idx === -1) {
        if (this.compareIds.length >= this.COMPARE_MAX) {
          var msg = _.i18n('compare.maxReached', null,
            'You can compare up to ' + this.COMPARE_MAX + ' products. Remove one first.');
          if (window.bootbox && window.bootbox.alert) {
            window.bootbox.alert(msg);
          } else {
            window.alert(msg);
          }
          return;
        }
        this.compareIds.push(id);
        // Capture a thumbnail snapshot so the tray can render after reload
        var snap = this._snapshotForItem(this._findItem(id));
        if (snap) { this.compareSnapshots[id] = snap; }
        $btn.addClass('is-active');
        $btn.closest('.result-card').addClass('is-compared');
      } else {
        this.compareIds.splice(idx, 1);
        delete this.compareSnapshots[id];
        $btn.removeClass('is-active');
        $btn.closest('.result-card').removeClass('is-compared');
      }
      this._writeCompareIds();
      this._writeCompareSnapshots();
      this._renderCompareTray();
    },

    onCompareClear: function (e) {
      try { e.preventDefault(); e.stopPropagation(); } catch (ex) {}
      this.compareIds = [];
      this.compareSnapshots = {};
      this._writeCompareIds();
      this._writeCompareSnapshots();
      this.$('.js-compare-btn.is-active').removeClass('is-active');
      this.$('.result-card.is-compared').removeClass('is-compared');
      this._renderCompareTray();
    },

    onCompareOpen: function (e) {
      try { e.preventDefault(); e.stopPropagation(); } catch (ex) {}
      if (!this.compareIds || this.compareIds.length === 0) { return; }
      App.navigate('pim/search/compare', {trigger: true});
    },

    onCompareTrayRemove: function (e) {
      try { e.preventDefault(); e.stopPropagation(); } catch (ex) {}
      var id = String($(e.currentTarget).attr('data-product-id') || '');
      if (!id) { return; }
      var idx = _.indexOf(this.compareIds, id);
      if (idx !== -1) {
        this.compareIds.splice(idx, 1);
        delete this.compareSnapshots[id];
        this._writeCompareIds();
        this._writeCompareSnapshots();
        this.$('.js-compare-btn[data-product-id="' + id + '"]').removeClass('is-active');
        this.$('.result-card[data-product-id="' + id + '"]').removeClass('is-compared');
        this._renderCompareTray();
      }
    },

    _renderCompareTray: function () {
      var $tray = this.$('.js-compare-tray');
      if (!$tray.length) { return; }
      var count = (this.compareIds || []).length;
      if (count === 0) {
        $tray.hide();
        return;
      }
      var that = this;
      var thumbsHtml = '';
      _.each(this.compareIds, function (id) {
        // Prefer the live item from the current results so the thumb reflects
        // the latest data; otherwise fall back to the persisted snapshot so the
        // tray still has a picture after a reload (before any search has run).
        var item = that._findItem(id);
        var snap = item ? that._snapshotForItem(item) : that.compareSnapshots[id];

        if (snap && snap.img) {
          thumbsHtml +=
            '<div class="pim-compare-tray-thumb" title="' + that._escape(snap.name || snap.code || id) + '">' +
            '  <img src="' + that._escape(snap.img) + '" alt="" loading="lazy" />' +
            '  <button class="pim-compare-tray-thumb-remove js-compare-tray-thumb-remove" data-product-id="' + that._escape(id) + '" title="Remove">×</button>' +
            '</div>';
        } else {
          thumbsHtml +=
            '<div class="pim-compare-tray-thumb is-placeholder" title="#' + that._escape(id) + '">' +
            '  <span class="pim-compare-tray-thumb-id">#' + that._escape(id) + '</span>' +
            '  <button class="pim-compare-tray-thumb-remove js-compare-tray-thumb-remove" data-product-id="' + that._escape(id) + '" title="Remove">×</button>' +
            '</div>';
        }
      });
      this.$('.js-compare-tray-thumbs').html(thumbsHtml);
      this.$('.js-compare-tray-count').text(String(count));
      this.$('.js-compare-open').prop('disabled', count < 2);
      $tray.show();
    }
  });

  module.exports = PimSearchView;
});

